import React from 'react';

export { default as OnboardingFlow } from './OnboardingFlow';
export { WelcomeLayout } from './WelcomeLayout';

export const WelcomeScreen = React.lazy(() => import('./WelcomeScreen'));
